__turbopack_context__.v({
  "heading": "U9TRFW_heading",
  "list": "U9TRFW_list",
});
